<template>
  <nav v-click-outside="{ handler: 'hideUserMenu' }" class="relative flex flex-col self-stretch max-w-2/3">
    <button
      ref="toggleButton"
      v-button-active-toggle
      class="flex p-6 text-left h-full items-center cursor-pointer"
      :aria-expanded="showUserMenu.toString()"
      aria-controls="menu"
      @click="toggleShowUserMenu"
    >
      <person-avatar
        :person="{
          name: {
            firstName: profile.name.firstName,
            lastName: profile.name.lastName
          },
          extSysApiUserId: profile.extSysApiUserId
        }"
        :tooltip="false"
        class="sm:pr-4 flex-shrink-0"
      />
      <div class="hidden sm:block font-semibold whitespace-no-wrap">
        {{ profile.name.firstName }}
      </div>
      <div class="ml-2 sm:ml-4 self-center">
        <svg
          class="fill-current opacity-50 w-2 transition-transform ease-out duration-200 rotate"
          viewBox="0 0 12 7"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M11 0L6 4 1 0 0 1l6 6 6-6-1-1z" />
        </svg>
      </div>
    </button>

    <ul
      v-if="showUserMenu"
      id="menu"
      role="menu"
      class="absolute bg-white text-black z-30 right-0 mr-px overflow-x-visible shadow-lg h-auto"
      style="top: 100%; width: fit-content"
      user-menu-container
    >
      <li class="bg-white flex flex-col text-black shadow-2xl w-50" role="menuitem">
        <button
          class="p-4 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none text-16 text-gray-800 font-semibold hover:underline"
          @click="logout"
        >
          Log ud
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

import PersonAvatar from "@/components/People/PersonAvatar";
import ClickOutside from "@/directives/ClickOutside";
import { useFeaturesStore } from "@/stores/features";
import { useMeStore } from "@/stores/me";
import ButtonActiveToggle from "@/directives/ButtonActiveToggle";

export default {
  name: "UserInfo",

  data() {
    return {
      user: null,
      userProfileImage: "",
      showUserMenu: false,
      isCustomerAdmin: false
    };
  },

  setup() {
    return {
      featuresStore: useFeaturesStore(),
      meStore: useMeStore()
    };
  },

  async mounted() {
    this.isCustomerAdmin = await this.meStore.loadTemporaryCustomerAdmin();
  },

  computed: {
    profile() {
      return this.meStore.profile;
    }
  },

  isSensitivityLabelFeatureActive() {
    return this.featuresStore.isFeatureEnabled("DocumentSensitivityLabels");
  },

  methods: {
    hideUserMenu() {
      this.$refs.toggleButton?.classList?.remove("button-active");
      this.showUserMenu = false;
    },

    toggleShowUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },

    logout() {
      SessionHelper.logout();
    }
  },

  components: {
    PersonAvatar
  },
  directives: {
    ClickOutside,
    ButtonActiveToggle
  }
};
</script>

<style scoped>
button.button-active .rotate {
  transform: rotate(-180deg);
}

[user-menu-container]::after {
  content: "";
  display: table;
  clear: both;
}
</style>
